import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M22 4H2v16h20V4zM9.5 16.5v-9l7 4.5-7 4.5z"
}), 'SmartDisplaySharp');